/**
 * Warns everyone in an organization whose subscription is past due. Access continues during the grace
 * period; the portal suspends the account when it ends. Only administrators get the payment link.
 */
import type { User } from '@/types/auth';

const PORTAL_URL = 'https://portal.velosynt.com';

function formatDate(value: string) {
  return new Date(value).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });
}

export default function BillingNotice({ user }: { user: User | null }) {
  if (user?.billing_status !== 'past_due') return null;
  const deadline = user.suspends_on ? ` on ${formatDate(user.suspends_on)}` : '';
  const admin = user.role === 'customer_admin' || user.role === 'platform_admin';
  return (
    <div role="alert" className="mb-6 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      <strong>Your organization's payment is past due.</strong>{' '}
      {admin ? (
        <>Access will be suspended{deadline} unless the balance is paid. <a className="font-semibold underline" href={PORTAL_URL} target="_blank" rel="noreferrer">Pay in the client portal</a></>
      ) : (
        <>Access will be suspended{deadline} unless the balance is paid. Contact your organization administrator.</>
      )}
    </div>
  );
}
